const checkIfMobile = (): boolean => {
  return navigator.userAgent.match(/Android/i) ||
    navigator.userAgent.match(/iPhone/i)
    ? true
    : false;
};

export default checkIfMobile;
